import { defineComponent as _defineComponent } from 'vue'
import CarouselTrackingService from 'JS/services/CarouselTrackingService';
import QuickAddProductDetails from './QuickAddProductDetails.vue';
import { createCarouselViewGtmData } from 'JS/utilities/carousel-tracking';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { IProductCarousel } from 'JS/types/Carousel';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickAddProducts',
  props: {
    carousel: null,
    fulfillmentType: null,
    loading: { type: Boolean },
    customTrackingUrl: null
  },
  emits: ["loading", "maxhit"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', loading: boolean): void,
	(e: 'maxhit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	carousel: IProductCarousel,
	fulfillmentType: FulfillmentType,
	loading: boolean,
	customTrackingUrl: string
}





const _trackingSvc = new CarouselTrackingService();
const viewImpressionUrl = ref<string>('');

onMounted(() => {
	if (viewImpressionUrl.value || !props.carousel) return;

	viewImpressionUrl.value = props.customTrackingUrl
		|| (window.location.pathname + window.location.search);

	const gtmData = createCarouselViewGtmData(props.carousel);

	_trackingSvc.trackViews([gtmData]);
});

function toggleLoading(loading) {
	emit('loading', loading);
}

function maxItemsHit() {
	emit('maxhit');
}


return { __sfc: true,props, emit, _trackingSvc, viewImpressionUrl, toggleLoading, maxItemsHit, QuickAddProductDetails }
}

})